import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import * as Constants from "Data/Constants";

import {ch3_p01} from "../../../layouts/ch3_p01/ch3_p01"

export class Chapter3Page1 extends AbstractStoryState {

	readonly bg = this.addChild(new SceneSprite());
	readonly bedMessy = this.addChild(new SceneSprite());
    readonly bedClean = this.addChild(new SceneSprite());
	readonly nightStand = this.addChild(new SceneSprite());
	readonly clothes = this.addChild(new SceneSprite());
	readonly floorItems = this.addChild(new SceneSprite());
	readonly holly = this.addChild(new SceneSprite());
	readonly basket = this.addChild(new SceneSprite());
	readonly basketLidOff = this.addChild(new SceneSprite());
	readonly basketLidOn = this.addChild(new SceneSprite());

	readonly frameLeft = this.addChild(new SceneSprite());
	readonly frameRight = this.addChild(new SceneSprite());
	readonly linesLeft = this.addChild(new SceneSprite());
    readonly linesRight = this.addChild(new SceneSprite());

	readonly list = this.addChild(SceneSprite.withPrefix("ch3_p01/"));

    public init(pSize: PIXI.Point, pData: any) {
		// exported layouts from Animate CC
        ch3_p01.call(this);
		this.frameLeft.visible = false;
		this.frameRight.visible = false;

        this.bedClean.visible = false;
        this.basketLidOn.visible = false;

        // interactivity
        this.list.interactive = true;
        this.list.buttonMode = true;
        this.list.accessible = true;
        this.list.addListener(HLF.Input.Events.POINTER_TAP, e=>{
            HLF.Application.instance.audio.play("HollyChoresListOpt1");
            this.gotoNextState({transition: "ontop"});
        });

		// super.init calls onResize
		super.init(pSize, pData);
	}

	public update(pDeltaTime: number) {
		super.update(pDeltaTime);
	}

	public animateOut(pOnComplete: ()=>void) {
        this.list.visible = false;
        super.animateOut(pOnComplete);
    }

	public animateIn(pOnComplete: ()=>void) {
        super.animateIn(pOnComplete);

        // set rooster and fence to same z depth
        this.bg.z = 4;
        this.bedMessy.z = 3;
        this.bedClean.z = 3;
        this.nightStand.z = 2;
        this.clothes.z = 4;
        this.floorItems.z = 2;
        this.holly.z = 2;
        this.basket.z = 1;
        this.basketLidOff.z = 1;
        this.basketLidOn.z = 1;
        this.linesLeft.z = 4;
        this.linesRight.z = 4;

		this.makeParallax([
            this.bg,
            this.bedMessy,
            this.bedClean,
            this.nightStand,
            this.clothes,
            this.floorItems,
            this.holly,
            this.basket,
            this.basketLidOff,
            this.basketLidOn,
            this.linesLeft,
            this.linesRight,
		], {duration: 4, distance: 8, spread: 10});

        // this.showHint(this.list, "pulse", 5);

        new TimelineLite()
            .fromTo(this.list, 2,
                {pixi: {y: this._size.y + this.list.height / 2}}, // offscreen
                {pixi: {y: this.list.y + 500}}, // start position in next panel
            )
            .delay(3.75)
        ;

        HLF.Application.instance.audio.play("HH_Ch3_Loop_LAYER1", undefined, true, HLF.AudioCategory.BGM);
	}
}